"use strict";

const form = document.getElementById('quote-form');
const contactform = document.getElementById('contact-form');
const missingError = document.getElementById('missingError');

const closestParent = (child, className) => {
  if (!child || child == document) {
    return null;
  }
  if (child.classList.contains(className)) {
    return child;
  } 
  else {
    return closestParent(child.parentNode, className);
  }
}

const resetFormGroup = (formGroup) => {
  formGroup.classList.remove("has-error");
  formGroup.classList.remove("has-success");
  formGroup.querySelectorAll(".help-block.error").forEach(el => el.parentNode.removeChild(el));
}

const showErrorsForInput = (input, errors) => {
  const formGroup = closestParent(input.parentNode, "form-entry");
  const warning = formGroup.querySelector(".form-input-warn");
  resetFormGroup(formGroup);
  if (errors) {
    window.scroll({ top: 0,left: 0,behavior: 'smooth' });

    missingError.classList.remove('hidden');
    formGroup.classList.add("has-error");
    for (let error of errors) {
      addError(warning, error);
    }
  } else {
    formGroup.classList.add("has-success");
    missingError.classList.add('hidden');
  }
}

const addError = (messages, error) => {
  let block = document.createElement("p");
  block.classList.add("help-block");
  block.classList.add("error");
  block.innerText = error;
  messages.appendChild(block);
}

const showErrors = (inputs,errors) => inputs.forEach(el => showErrorsForInput(el, errors && errors[el.name]));

validate.extend(validate.validators.datetime, {
  parse: function(value) {
    return +moment.utc(value);
  },
  format: function(value) {
    return moment.utc(value).format("YYYY-MM-DD");
  }
});

validate.validators.time = (value) => {
  if (moment(value, "HH:mm", true).isValid() === true) {
    return null
  } 
  else if (moment(value, "h:mm a", true).isValid() === true) {
    return null
  }
  else {
    return "incorrect";
  }
};

if (form) {
  const submitBtn = document.querySelector('.form-submit');
  const inputs = [...form.querySelectorAll('input,select,textarea')].filter(element => element.classList.contains('validate'));
  let constraints = {
    'first-name': {
      presence: true,
    },
    'last-name': {
      presence: true,
    },
    email: {
      presence: true,
      email: true
    },
    zip: {
      presence: false,
      format: '[0-9]*'
    },
    phone: {
      presence: true,
    },
    'departure-city': {
      presence: true,
    },
    'departure-date': {
      presence: true,
      datetime: true
    },
    'departure-time': {
      time: true
    },
    'destination-city': {
      presence: true,
    },
    'trip-type': {
      presence: {message: "^Please select one"}
    },
    'number-of-passengers': {
      presence: {message: "^Please select one"}
    },
    'return-time': {
      time: true
    },
    'return-date': {
      presence: true,
      datetime: true
    },
  };

  const foundDate = inputs.find(element => element.name === 'return-date');
  const foundTime = inputs.find(element => element.name === 'return-time');

  for (let input of inputs) {
    input.addEventListener('change', (e) => {
      if (e.target.name === 'departure-date'){
        foundDate.value = e.target.value;
        foundDate.min = e.target.value;
      }
      if (e.target.name === 'trip-type' && e.target.value === 'One Way'){
        foundDate.disabled = true;
        foundTime.disabled = true;
        constraints["return-date"].presence = false;
        constraints["return-time"].time = false;
      }
      if (e.target.name === 'trip-type' && e.target.value === 'Round Trip'){
        foundDate.disabled = false;
        foundTime.disabled = false;
        constraints["return-date"].presence = true;
        constraints["return-time"].time = true;
      }
      const errors = validate(form, constraints) || {};
      showErrorsForInput(input, errors[input.name])
    })
  }

  submitBtn.onclick = e => {
    e.preventDefault();
    grecaptcha.ready(function() {
      grecaptcha.execute('6LcOrNoZAAAAAAaK1HtxXoWhkTNVuk971wG3DLXC', {action: 'submit'}).then(function(token) {
        document.getElementById('token').value = token;
        const errors = validate(form, constraints);
        showErrors(inputs,errors || {});
        if (errors) return;
        document.forms['quote-form'].submit();
      });
    });
  }
}

if (contactform) {
  const submitBtn = document.querySelector('.form-submit');
  const inputs = [...contactform.querySelectorAll('input,select,textarea')].filter(element => element.classList.contains('validate'));
  const constraints = {
    'first-name': {
      presence: true,
    },
    'last-name': {
      presence: true,
    },
    email: {
      presence: true,
      email: true
    },
    phone: {
      presence: true,
    }
  };

  for (let input of inputs) {
    input.addEventListener('change', () => {
      const errors = validate(contactform, constraints) || {};
      showErrorsForInput(input, errors[input.name])
    })
  }

  submitBtn.onclick = e => {
    e.preventDefault();
    grecaptcha.ready(function() {
      grecaptcha.execute('6LcOrNoZAAAAAAaK1HtxXoWhkTNVuk971wG3DLXC', {action: 'homepage'}).then(function(token) {
        document.getElementById('token').value = token;
        const errors = validate(contactform, constraints);
        showErrors(inputs,errors || {});
        if (errors) return;
        document.forms['contact-form'].submit();
      });
    });
  }
}